<template>
  <DocumillDropdownMenu>
    <template #trigger>
      <DocumillIconButton v-if="loggedIn == true"
        iconName="globe"
        >
        {{ this.$t(`user_profile.selected_language.${$i18n.locale}`) }}
      </DocumillIconButton>
      <DocumillDropdownInline v-else
        icon="globe"
        :label="label"
        :style="labelColor ? `--color-control-textual-default: ${labelColor}` : undefined"
        >
        {{ this.$t(`user_profile.selected_language.${$i18n.locale}`) }}
      </DocumillDropdownInline>
    </template>
    <DocumillDropdownItem
      v-for="locale in $i18n.availableLocales"
      :key="`locale-${locale}`"
      @click="updateLocale(locale);"
    >{{ this.$t(`user_profile.selected_language.${locale}`) }}</DocumillDropdownItem>
  </DocumillDropdownMenu>
</template>

<script>

import { DocumillDropdownInline, DocumillIconButton, DocumillDropdownMenu, DocumillDropdownItem } from "documill-ui-library";
import LocalStorage from "./../../utils/localStorage";

export default {
  name: "GuestLocaleDropdownMenu",
  components: {
    DocumillDropdownInline,
    DocumillDropdownMenu,
    DocumillDropdownItem,
    LocalStorage,
    DocumillIconButton
  },

  methods: {
    updateLocale: function (locale) {
      this.$i18n.locale = locale;
      LocalStorage.setGuestLocale(locale);
    },
  },

  mounted: function () {
    let storedGuestLocale = LocalStorage.getGuestLocale();
    if(storedGuestLocale) {
      this.$i18n.locale = storedGuestLocale;
    }
  },

  props: {
    /** Whether to show the dropdown menu label. */
    label: {
      type: Boolean,
      default: true
    },
    labelColor: {
      type: String,
      default: null
    },
    loggedIn : {
      type: Boolean,
      default: false
    }    
  },
};
</script>
